import styled from '@emotion/styled';
import { Card } from 'antd';

export const StyledCard = styled(Card)`
  margin: 30px auto;
  width: calc(100% - 60px);
  min-width: 600px;
  box-sizing: border-box;
`;

export const KPICard = styled(Card)`
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #e8e8e8;
  height: 100%;
  min-height: 140px;
  .ant-card-body {
    padding: 16px;
    height: 100%;
  }
`;

export const SectionTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #262626;
`;

export const TagSummaryCard = styled(Card)`
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  background: #fafafa;
  height: 100%;
  .ant-card-body {
    padding: 16px;
    max-height: 280px;
    overflow-y: auto;
  }
`;

export const ReviewMetricCard = styled(Card)`
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  height: 100%;
  min-height: 100px;
  .ant-card-body {
    padding: 16px;
    height: 100%;
    min-height: 100px;
  }
`;
